export { default as ArrowsExpandOutlineIcon } from './ArrowsExpandOutlineIcon';
